import { Button, Grid, Group, Modal, Text } from '@mantine/core';
import { IconCloudDownload } from '@tabler/icons-react';
import LabeledSlider from '../LabeledSlider';
import { useState } from 'react';
import { useParams } from 'react-router';
import { productsRangeToExport } from '../../constants/exportProductsRange';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import SegmentSelector from '../Segments/SegmentSelector';

const ProductFeedExportModal = ({ isOpen, close, scheduled, productFeed, segments }) => {
  const { accountId, domainId } = useParams();
  const fetch = useFetch();

  const [segmentId, setSegmentId] = useState(segments[0]?.id);
  const [productsCount, setProductCount] = useState(productsRangeToExport.min);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState();

  if (!productFeed) {
    return;
  }

  const exportFeed = () => {
    setExporting(true);
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/productFeeds/exports`, {
      method: 'POST',
      body: JSON.stringify({
        count: productsCount,
        segmentId,
        productFeedId: productFeed.id.toString(),
        productFeedName: productFeed.name,
      }),
    })
      .then(() => {
        scheduled();
        setExporting(false);
      })
      .catch(setError);
  };

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  const isAdsScope = productFeed.scope === 'ads';

  return (
    <Modal size="xl" opened={isOpen} onClose={() => close()} title="Export Ranked Products from Feed">
      {!isAdsScope && (
        <SegmentSelector
          title="Ranking Segment"
          description="Products will be ranked and filtered based on user preferences from this segment."
          segmentId={segmentId}
          onSelect={(segment) => setSegmentId(segment?.id)}
          campaignScope="transactional"
          scope="behavior"
        />
      )}
      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
          <label>
            Max products to export: <strong>{productsCount}</strong>
          </label>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 8 }}>
          <LabeledSlider
            min={productsRangeToExport.min}
            max={productsRangeToExport.max}
            value={productsCount}
            onChange={(count) => setProductCount(count)}
          />
          <Text size="xs" c="dimmed" mt="xs">
            {isAdsScope
              ? 'The actual number depends on the product feed configuration.'
              : 'The actual number depends on the the product feed configuration and the user preferences in the segment.'}
          </Text>
        </Grid.Col>
      </Grid>
      <Group justify="flex-end" mt="md">
        <Button variant="default" onClick={() => close()}>
          Close
        </Button>
        <Button
          disabled={exporting || (!isAdsScope && !segmentId)}
          onClick={exportFeed}
          leftSection={<IconCloudDownload size={16} />}
        >
          Export
        </Button>
      </Group>
    </Modal>
  );
};

export default ProductFeedExportModal;
